export enum HealthReportDashboardTypeEnum {
    NONE = 0,
    LAST_24H = 1,
    LAST_7DAYS = 2,
    LAST_30DAYS = 3,
    TRENDS = 4,
}
